import { useNavigate, useParams } from "react-router-dom";
import * as L from "leaflet";

import { Pane } from "src/components/Pane";
import { ResidentialZoneCreatePage } from "./ResidentialZoneCreatePage";
import { ResidentialZoneEditPage } from "./ResidentialZoneEditPage";

interface Props {
  map: L.Map;
}

export function ResidentialZonePage(props: Props) {
  const navigate = useNavigate();
  const params = useParams<{
    caseId: string;
    scenarioId: string;
    residentialZoneId: string;
  }>();

  function handleClose() {
    navigate(`/cases/${params.caseId}/scenarios/${params.scenarioId}/residential-zones`);
  }

  return render();

  function render() {
    if (params.residentialZoneId === "new") {
      return (
        <Pane>
          <ResidentialZoneCreatePage onClose={handleClose} {...props} />
        </Pane>
      );
    }
    // else
    return (
      <Pane>
        <ResidentialZoneEditPage
          key={[params.caseId, params.scenarioId, params.residentialZoneId].join()}
          onClose={handleClose}
          {...props}
        />
      </Pane>
    );
  }
}
